import type { FC } from 'react';
import { Ratings as TamagoshiRatings } from '@/core/tamagoshi/Ratings/Ratings';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import type { RichTextFormatter } from '@/domains/core/localization/translate';
import { isB2B } from '@/domains/core/settings/utils';
import { RatingBars } from '@/domains/productDiscovery/ArticleReviews/components/RatingBars/RatingBars';
import { useReviewsStats } from '@/domains/productDiscovery/ArticleReviews/ReviewsStats.ducks';
import { reviewsBlockTitle, reviewsOneGlobalRating, reviewsOtherGlobalRating } from '@/domains/productDiscovery/ArticleReviews/translations';
import { StringAbTests } from '@/productDiscovery/ProductPage/constants';
import styles from './reviewsStatsModal.module.scss';
interface Props {
  toggleStarsFilter: (rating: number) => void;
  clearStarsFilter: () => void;
  starsFilter: number | null;
}
const strongFormatter: RichTextFormatter = chunks => <b key="strong-formatter">{chunks}</b>;
export const ReviewsStatsModal: FC<Props> = ({
  toggleStarsFilter,
  clearStarsFilter,
  starsFilter
}) => {
  const [isProductPageRevampEnabled] = useBooleanFlags([StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP]);
  const {
    average,
    distribution,
    total
  } = useReviewsStats();
  const rating = average?.toFixed(1).replace('.', ',');
  return <>
      <h2 className={styles.textTitle}>{reviewsBlockTitle}</h2>
      <div className={styles.statsContainer}>
        <div className={styles.rateContainer}>
          <div>
            <span className={styles.rate} aria-label={rating}>
              {rating}
            </span>
            <span className={styles.total} aria-label="/5">
              /5
            </span>
          </div>
          <div className={styles.ratingContainer}>
            <TamagoshiRatings nbStars={average} />
            <div className={styles.ratingText}>
              {total === 1 ? reviewsOneGlobalRating.format({
              total,
              strong: strongFormatter
            }) : reviewsOtherGlobalRating.format({
              total,
              strong: strongFormatter
            })}
            </div>
          </div>
        </div>

        {!(isB2B() && isProductPageRevampEnabled) && <RatingBars distribution={distribution} starsFilter={starsFilter} toggleStarsFilter={toggleStarsFilter} clearStarsFilter={clearStarsFilter} isModal />}
      </div>
    </>;
};
ReviewsStatsModal.displayName = 'ReviewsStatsModal';